export default "__VITE_ASSET__C9CAdoj1__"